<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap5">FIVE</h1>
<p class="noind" style="margin-top:30px;">A <span class="small">COLD WIND BLEW OVER</span> the slopes of Olympus. Aphrodite walked out of the garden and into the orchard. The pomegranate trees were being stripped by the wind, and the fig trees and the wild olives. But standing green among the fruit trees were fir and spruce and pine. Snow began to sift. Olympus stands in northern Thessaly; it is capped by snow from autumn till spring. It was autumn now. She was barefoot, clad in a blue tunic. Her throat was bare, and her shoulders and her long white arms.</p>
<p class="ind">A bright yell split the air—Hermes’ herald call. He flashed like a blade, catching all the dull light. She watched as he fell toward her, his face drinking light.</p>
<p class="ind">He saw her among trees in the cold green dusk, growing taller and taller as he coasted down steeps of air into the clean smell of pine. He came to her. He saw snow melting about her feet and roses springing where she stood.</p>
<p class="ind">“You sent for me, O beautiful one?”</p>
<p class="ind">“I need your help.”</p>
<p class="ind">“Queen of the Night, whatever is in my power I shall perform.”</p>
<p class="ind">“I have chosen again among mortals.”</p>
<p class="ind">“Let me guess the rest. You want my assistance in defending him against the jealous gods.”</p>
<p class="ind">“He is startlingly like Adonis. Not surprising: he is also descended from Io.”</p>
<p class="ind">“Therefore, perhaps, one of my own descendants,” murmured Hermes.</p>
<p class="ind">“Quite possibly, dear friend. He is Jason, exiled prince of Iolcus, dwelling now upon the island of Cythera.”</p>
<p class="ind">“Does Ares know about him?”</p>
<p class="ind">“I don’t see how he could. I don’t visit the island. Not yet.”</p>
<p class="ind">“Well, if Ares doesn’t know …”</p>
<p class="ind">“In that brawling bully, jealousy becomes insight. He has an uncanny way of sniffing out my favorites. But I shall not permit Jason to meet the doom of Adonis.”</p>
<p class="ind">“And what do you expect me to do—go to battle with the god of war? Do you really think that I, the most fragile and least bellicose of the Olympians, can stop that murderous brute in the full spate of his wrath?”</p>
<p class="ind">“I’m not asking you to fight him. I need your wits, not your sword. As I say, I don’t know that he’s even aware of Jason’s existence, but I would like you to fly over the island. Just look things over, make sure my sentinel witch is being vigilant or see if I shall have to take stronger measures.”</p>
<p class="ind">“I don’t relish this chore, but I can refuse you nothing.”</p>
<p class="ind">“You’ll find me grateful.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9chap5.vue?0131844f